import React from 'react'
import MainLayout from '../../components/main-layout'
import FinanceInventoryProvider from './data-handling/finance-inventory-provider'
import HeaderComponent from '../../layouts/header'
import history from '../../history'
import MainView from './containers/main-view'

function FinanceInventoryModule() {

  return (
    <MainLayout activeTabIndex={8}>
      <HeaderComponent
        headingText={"Add Item"}
        showBackBtn={true}
        onBackBtnClick={() => history.back()}
      ></HeaderComponent>
      <FinanceInventoryProvider>
        <MainView/>
      </FinanceInventoryProvider>
    </MainLayout>
  )
}

export default FinanceInventoryModule
